import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { toast, ToastContainer } from 'react-toastify';

const normalize = (str) => str?.toLowerCase().replace(/[^a-z]/g, '');

const CauseList = () => {
  const [allCauses, setAllCauses] = useState([]);
  const [visibleCauses, setVisibleCauses] = useState([]);
  const [activeFilter, setActiveFilter] = useState('View all');
  const [showQR, setShowQR] = useState(false);
  const [selectedCause, setSelectedCause] = useState({});

  const filterCategories = [
    'Masjid Construction',
    'Madrasa',
    'Imaam & Mauzin Funds',
    'Maktab & syllabaus',
    'Social Work',
    'View all',
  ];

  useEffect(() => {
    const fetchCauses = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_REQUESTING_API}/api/causes`);
        const sorted = res.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setAllCauses(sorted);
        setVisibleCauses(sorted);
      } catch (err) {
        console.error('Failed to fetch causes:', err);
      }
    };

    fetchCauses();
  }, []);

  const handleFilter = (category) => {
    setActiveFilter(category);
    
    if (category === 'View all') {
      setVisibleCauses(allCauses);
    } else {
      const normCategory = normalize(category);
      const filtered = allCauses.filter((c) =>
        normalize(c.cause || '').includes(normCategory) || normCategory.includes(normalize(c.cause || ''))
      );
      setVisibleCauses(filtered);
    }
  };

  const isMobile = () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  const handleDonate = (cause, donationFor) => {
    setSelectedCause({ cause, donationFor });
    
    const upiId = "yourupiid@okaxis"; // 🔴 REPLACE with real UPI ID
    const name = "SUBAI JAMIAT AHLE HADEES ANDHRA PRADESH";

    if (isMobile()) {
      const upiUrl = `upi://pay?pa=${upiId}&pn=${encodeURIComponent(name)}&cu=INR&tn=${encodeURIComponent(donationFor)}`;
      window.location.href = upiUrl;
    } else {
      setShowQR(true);
      // Auto close popup after 8 seconds
      setTimeout(() => {
        setShowQR(false);
      }, 8000);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <ToastContainer position="top-right" autoClose={3000} />
      
      {/* Hero Section */}
      <div className="relative">
        <img
          className="object-cover w-full h-[400px] md:h-[600px]"
          src="images/donaters.jpg"
          alt="Donation Banner"
        />
        <div className="absolute inset-0 flex flex-col justify-center items-center text-center bg-black bg-opacity-50">
          <h1 className="text-3xl md:text-4xl lg:text-5xl text-white font-bold px-4">
            وَالَّذِينَ جَاهَدُوا فِينَا لَنَهْدِيَنَّهُمْ سُبُلَنَا
          </h1>
          <p className="text-base md:text-lg text-white p-6 max-w-3xl">
            "And those who strive for Us, We will surely guide them to Our ways..."
            <br />
            <span className="italic">— Surah Al-Ankabut (29:69)</span>
          </p>
        </div>
      </div>

      {/* Main Content with Sidebar */}
      <div className="container mx-auto px-4 py-8 sm:py-12">
        <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
          {/* Left Sidebar - Filter */}
          <aside className="w-full lg:w-64 flex-shrink-0">
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6 lg:sticky lg:top-4">
              <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-4 sm:mb-6">Filter by Cause</h2>
              
              {/* Mobile: Horizontal scroll */}
              <nav className="flex lg:flex-col gap-2 overflow-x-auto lg:overflow-x-visible pb-2 lg:pb-0 -mx-4 px-4 lg:mx-0 lg:px-0">
                {filterCategories.map((category) => (
                  <button
                    key={category}
                    onClick={() => handleFilter(category)}
                    className={`whitespace-nowrap lg:w-full text-left px-4 py-2.5 sm:py-3 rounded-lg transition-all duration-200 text-sm sm:text-base ${
                      activeFilter === category
                        ? 'bg-gray-800 text-white font-medium'
                        : 'text-gray-700 hover:bg-gray-100 bg-gray-50 lg:bg-transparent'
                    }`}
                  >
                    {category}
                  </button>
                ))}
              </nav>
            </div>
          </aside>

          {/* Right Content - Causes Grid */}
          <main className="flex-1">
            <div className="mb-4 sm:mb-6">
              <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">
                {activeFilter === 'View all' ? 'Explore all causes' : activeFilter}
              </h1>
              <p className="text-gray-600 mt-1 sm:mt-2 text-sm sm:text-base">
                {visibleCauses.length} {visibleCauses.length === 1 ? 'cause' : 'causes'} available
              </p>
            </div>

            {visibleCauses.length === 0 ? (
              <div className="bg-white rounded-lg shadow-sm p-12 text-center">
                <p className="text-gray-500 text-lg">No causes found for this category.</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-6">
                {visibleCauses.map((cause, index) => (
                
                
               <div
  key={index}
  className="group relative rounded-2xl overflow-hidden
             bg-gradient-to-br from-gray-900 via-gray-800 to-black
             shadow-[0_8px_32px_rgba(0,0,0,0.4)]
             hover:shadow-[0_16px_48px_rgba(0,0,0,0.6)]
             transition-all duration-500
             border border-white/10"
>
  {/* Image Section with Glass Overlay */}
  <div className="relative h-56 sm:h-64 overflow-hidden">
    <Carousel 
      showThumbs={false} 
      infiniteLoop 
      autoPlay 
      showIndicators={false}
      showStatus={false}
      interval={4000}
      className="h-full"
    >
      {cause.images.map((img, i) => (
        <div key={i} className="h-56 sm:h-64">
          <img
            src={`data:image/jpeg;base64,${img}`}
            alt={`Image ${i + 1}`}
            className="w-full h-full object-cover 
                     scale-105 group-hover:scale-110 
                     transition-transform duration-700"
          />
        </div>
      ))}
    </Carousel>

    {/* Dark Gradient Mask - Stronger at bottom for text readability */}
    <div className="absolute inset-0 bg-gradient-to-b 
                    from-black/30 via-black/50 to-black/95" />

    {/* Glass Overlay Layer */}
    <div className="absolute inset-0 bg-white/5 backdrop-blur-[0.5px]" />

    {/* Category Badge - Top Left */}
    <div className="absolute top-4 left-4 z-10">
      <span className="inline-block px-4 py-2 rounded-full
                     bg-white/15 backdrop-blur-md
                     border border-white/30
                     text-white text-sm font-bold uppercase tracking-wider
                     shadow-[0_4px_12px_rgba(0,0,0,0.3)]
                     drop-shadow-[0_2px_4px_rgba(0,0,0,0.5)]">
        {cause.cause}
      </span>
    </div>

    {/* Main Title - Bottom of Image with Glass Background */}
    <div className="absolute bottom-0 left-0 right-0 z-10 p-5 
                    bg-gradient-to-t from-black/90 via-black/70 to-transparent">
      <div className="bg-white/10 backdrop-blur-md border border-white/20 
                      rounded-xl p-4 shadow-[0_8px_24px_rgba(0,0,0,0.4)]">
        <p className="text-white/70 text-xs font-bold uppercase tracking-wider mb-2 
                      drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]">
          Donation For
        </p>
        <h3 className="text-white text-lg sm:text-xl font-bold leading-tight 
                       line-clamp-2 drop-shadow-[0_2px_8px_rgba(0,0,0,0.9)]">
          {cause.donationFor}
        </h3>
        <div className="h-1 w-20 bg-gradient-to-r from-white/90 to-transparent 
                        rounded-full mt-3 shadow-[0_2px_8px_rgba(255,255,255,0.3)]"></div>
      </div>
    </div>
  </div>

  {/* Content Section with Glass Background */}
  <div className="relative p-6 flex-1 flex flex-col 
                bg-gradient-to-b from-black/80 to-black">

    {/* Details Grid in Glass Panel */}
    <div className="mb-5 flex-1">
      <div className="bg-white/5 backdrop-blur-sm 
                    border border-white/10 
                    rounded-xl p-5 space-y-4">

        {/* Contact Person */}
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center">
            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-white/60 text-xs font-medium uppercase tracking-wider mb-1">
              Contact Person
            </p>
            <p className="text-white text-base font-semibold truncate">
              {cause.name}
            </p>
          </div>
        </div>

        {/* Phone Number */}
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center">
            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-white/60 text-xs font-medium uppercase tracking-wider mb-1">
              Phone Number
            </p>
            <p className="text-white text-base font-semibold tracking-wide truncate">
              {cause.number}
            </p>
          </div>
        </div>

        {/* Location */}
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center">
            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-white/60 text-xs font-medium uppercase tracking-wider mb-1">
              Location
            </p>
            <p className="text-white text-sm font-medium leading-snug line-clamp-2">
              {cause.address}
            </p>
          </div>
        </div>

        {/* Description */}
        <div className="pt-3 border-t border-white/10">
          <p className="text-white/60 text-xs font-medium uppercase tracking-wider mb-2">
            About
          </p>
          <p className="text-white/90 text-sm font-normal leading-relaxed line-clamp-3">
            {cause.description}
          </p>
        </div>

      </div>
    </div>

    {/* Donate Button - Glass Style */}
    <button
      onClick={() => handleDonate(cause.cause, cause.donationFor)}
      className="w-full py-3.5 rounded-xl
               bg-white/95 backdrop-blur-md
               hover:bg-white
               text-black font-bold uppercase tracking-wider
               text-sm
               flex items-center justify-center gap-2
               transition-all duration-300
               shadow-[0_4px_16px_rgba(255,255,255,0.2)]
               hover:shadow-[0_6px_24px_rgba(255,255,255,0.3)]
               hover:scale-[1.02]
               border border-white/20"
    >
      <span>Donate Now</span>
      <svg 
        className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M17 8l4 4m0 0l-4 4m4-4H3" />
      </svg>
    </button>
  </div>
</div>




                ))}
              </div>
            )}
          </main>
        </div>
      </div>

      {/* Desktop QR Popup */}
      {showQR && (
        <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4">
          <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-2xl max-w-sm w-full text-center relative">
            {/* Close Button */}
            <button
              onClick={() => setShowQR(false)}
              className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <h2 className="font-black text-xl sm:text-2xl mb-2">
              Scan to Donate
            </h2>

            <p className="text-sm text-gray-600 mb-1">
              {selectedCause.donationFor}
            </p>
            <p className="text-xs text-gray-500 mb-4">
              Use Google Pay / PhonePe / Paytm / Any UPI App
            </p>

            <div className="bg-gray-50 p-4 rounded-xl">
              <img
                src="images/maekazqr.png" // 🔴 REPLACE with your QR image
                alt="Donate QR"
                className="mx-auto w-56 h-56 sm:w-64 sm:h-64"
              />
            </div>

            <p className="text-xs text-gray-500 mt-4">
              This popup will close automatically in 8 seconds
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CauseList;






// old working 16/12/25


// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Carousel } from 'react-responsive-carousel';
// import 'react-responsive-carousel/lib/styles/carousel.min.css';
// import { toast, ToastContainer } from 'react-toastify';

// const normalize = (str) => str?.toLowerCase().replace(/[^a-z]/g, '');

// const CauseList = () => {
//   const [allCauses, setAllCauses] = useState([]);
//   const [visibleCauses, setVisibleCauses] = useState([]);
//   const [filteredCause, setFilteredCause] = useState(null);
//   const [defaultDisplayCauses, setDefaultDisplayCauses] = useState([]);
//   const [showPopup, setShowPopup] = useState(false);
//   const [selectedCause, setSelectedCause] = useState({});
//   const [form, setForm] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     amount: '',
//   });

//   const targetCauses = [
//     'Masjid Construction',
//     'Madrasa',
//     'Imaam & Mauzin Funds',
//     'Maktab & syllabaus',
//     'Social Work',
//   ];

//   useEffect(() => {
//     const fetchCauses = async () => {
//       try {
//         const res = await axios.get(`${process.env.REACT_APP_REQUESTING_API}/api/causes`);
//         const sorted = res.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
//         setAllCauses(sorted);

//         const display = targetCauses.map((type) => {
//           const normalizedType = normalize(type);
//           const found = sorted.find((item) => {
//             const itemNorm = normalize(item.cause || '');
//             return itemNorm.includes(normalizedType) || normalizedType.includes(itemNorm);
//           });
//           return found || { cause: type, empty: true };
//         });

//         setDefaultDisplayCauses(display);
//         setVisibleCauses(display);
//       } catch (err) {
//         console.error('Failed to fetch causes:', err);
//       }
//     };

//     fetchCauses();
//   }, []);

//   const handleFilter = (causeType) => {
//     const normType = normalize(causeType);
//     const filtered = allCauses.filter((c) =>
//       normalize(c.cause || '').includes(normType) || normType.includes(normalize(c.cause || ''))
//     );
//     setFilteredCause(causeType);
//     setVisibleCauses(filtered);
//   };

//   const handleReset = () => {
//     setFilteredCause(null);
//     setVisibleCauses(defaultDisplayCauses);
//   };

//   const handleDonate = (cause, donationFor) => {
//   setSelectedCause({ cause, donationFor });
//   setShowPopup(true);
// };

// const startRazorpay = async () => {
//   const { name, email, phone, amount } = form;

//   if (!name || !phone || !amount) {
//     toast.error('Please enter Name, Phone, and Amount');
//     return;
//   }

//   try {
//     const res = await axios.post(`${process.env.REACT_APP_REQUESTING_API}/api/donate`, {
//       amount,
//       type: 'onetime',
//       cause: selectedCause.cause,
//       donationFor: selectedCause.donationFor,
//       name,
//       email,
//       phone,
//     });

//     const { order } = res.data;

//     const options = {
//       key: process.env.REACT_APP_RAZORPAY_KEY_ID,
//       order_id: order.id,
//       currency: 'INR',
//       name: 'SUBAI JAMIAT AHLE HADEES ANDHRA PRADESH',
//       description: 'Donation Payment',
//       prefill: {
//         name,
//         email,
//         contact: phone,
//       },
//       notes: {
//         name,
//         cause: selectedCause.cause,
//         donationFor: selectedCause.donationFor,
//       },
//       handler: function (response) {
//         toast.success('Payment successful! ID: ' + response.razorpay_payment_id);
//         setShowPopup(false);
//         setForm({ name: '', email: '', phone: '', amount: '' });
//       },
//       theme: {
//         color: '#0f766e',
//       },
//     };

//     const rzp = new window.Razorpay(options);
//     rzp.open();
//   } catch (err) {
//     console.error('Payment initiation failed', err);
//     toast.error('Payment initiation failed');
//   }
// };


//   return (
//     <div className="pb-[700px] md:pb-[420px] lg:pb-[320px]">
//        <ToastContainer position="top-right" autoClose={3000} />
//       {/* Hero */}
//       <div className="relative">
//         <img
//           className="object-cover w-full h-[600px] md:h-[800px]"
//           src="images/donaters.jpg"
//           alt="Donation Banner"
//         />
//         <div className="absolute inset-0 flex flex-col justify-center items-center text-center bg-black bg-opacity-50">
//           <h1 className="text-4xl md:text-5xl lg:text-6xl text-white font-bold">
//             وَالَّذِينَ جَاهَدُوا فِينَا لَنَهْدِيَنَّهُمْ سُبُلَنَا
//           </h1>
//           <p className="text-lg md:text-xl text-white p-6 max-w-3xl">
//             "And those who strive for Us, We will surely guide them to Our ways..."
//             <br />
//             <span className="italic">— Surah Al-Ankabut (29:69)</span>
//           </p>
//         </div>
//       </div>

//       {/* Back Button */}
//       {filteredCause && (
//         <div className="text-center pt-12 pb-32 relative z-50">
//           <button
//             onClick={(e) => {
//               e.stopPropagation();
//               handleReset();
//             }}
//             className="bg-gray-500 text-white px-4 py-2 rounded z-50 relative"
//           >
//             Back to All Causes
//           </button>
//         </div>
//       )}

//       {/* Cause Cards */}
//       <div className="relative -mt-[100px] md:-mt-[200px] grid grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 p-5 lg:p-32">
//         {visibleCauses.map((cause, index) => (
//           <div
//             key={index}
//             onClick={() => {
//               if (
//                 !filteredCause &&
//                 !cause.empty &&
//                 ['Masjid Construction', 'Madrasa'].includes(cause.cause)
//               ) {
//                 handleFilter(cause.cause);
//               }
//             }}
//             className={`flex flex-col relative ${!cause.empty ? 'cursor-pointer' : 'opacity-50'}`}
//           >
//             <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-200 transform transition-transform duration-300 hover:scale-105 relative flex flex-col h-[650px] overflow-hidden">
//               {/* <div className="absolute z-50 top-4 right-4 bg-green-500 text-white text-lg px-3 py-1 rounded-full">
//                 {cause.cause}
//               </div> */}

//               {cause.empty ? (
//                 <div className="flex flex-col justify-center items-center h-full text-gray-400 italic">
//                   No causes available for this category yet.
//                 </div>
//               ) : (
//                 <>
//                   <Carousel showThumbs={false} infiniteLoop autoPlay showIndicators={false}>
//                     {cause.images.map((img, i) => (
//                       <div key={i}>
//                         <img
//                           src={`data:image/jpeg;base64,${img}`}
//                           alt={`Image ${i + 1}`}
//                           className="w-full h-80 object-cover"
//                         />
//                       </div>
//                     ))}
//                   </Carousel>

//                   <div className="flex-1 mt-4 space-y-1">
//                     <p className="text-gray-700 text-md">
//                       <span className="font-semibold">Donation For:</span> {cause.donationFor}
//                     </p>
//                     <p className="text-gray-700 text-md">
//                       <span className="font-semibold">Point of Contact:</span> {cause.name}
//                     </p>
//                     <p className="text-gray-500 text-md">
//                       <span className="font-semibold">Phone:</span> {cause.number}
//                     </p>
//                     <p className="text-gray-500 text-md line-clamp-2">
//                       <span className="font-semibold">Address:</span> {cause.address}
//                     </p>
//                     <p className="text-gray-500 text-md line-clamp-3">
//                       <span className="font-semibold">Description:</span> {cause.description}
//                     </p>
//                   </div>

//                   <div className="mt-4">
//                     <button
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleDonate(cause.cause, cause.donationFor);
//                       }}
//                       className="w-full px-4 py-2 text-white bg-zinc-500 rounded hover:bg-zinc-800"
//                     >
//                       Donate
//                     </button>

//                     {!filteredCause &&
//                       ['Masjid Construction', 'Madrasa'].includes(cause.cause) && (
//                         <p className="text-center mt-4 text-blue-600 font-semibold underline">
//                           Click to view all {cause.cause} causes
//                         </p>
//                       )}
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Prefill Popup */}
//       {showPopup && (
//         <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 z-50">
//           <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-xl space-y-4">
//             <h2 className="text-xl font-semibold text-center">Enter Your Details</h2>
//             <input
//               type="text"
//               placeholder="Your Name"
//               value={form.name}
//               onChange={(e) => setForm({ ...form, name: e.target.value })}
//               className="w-full p-2 border rounded"
//               required
//             />
//             <input
//               type="tel"
//               placeholder="Phone Number"
//               value={form.phone}
//               onChange={(e) => setForm({ ...form, phone: e.target.value })}
//               className="w-full p-2 border rounded"
//               required
//             />
//             <input
//               type="email"
//               placeholder="Email (optional)"
//               value={form.email}
//               onChange={(e) => setForm({ ...form, email: e.target.value })}
//               className="w-full p-2 border rounded"
//             />
//             <input
//               type="number"
//               placeholder="Amount (₹)"
//               value={form.amount}
//               onChange={(e) => setForm({ ...form, amount: e.target.value })}
//               className="w-full p-2 border rounded"
//               required
//             />
//             <div className="flex justify-between pt-2">
//               <button
//                 onClick={() => setShowPopup(false)}
//                 className="px-4 py-2 bg-gray-400 text-white rounded"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={startRazorpay}
//                 className="px-4 py-2 bg-green-600 text-white rounded"
//               >
//                 Pay Now
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CauseList;


// working 03/july/2025
// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Carousel } from 'react-responsive-carousel';
// import 'react-responsive-carousel/lib/styles/carousel.min.css';

// const normalize = (str) => str?.toLowerCase().replace(/[^a-z]/g, '');

// const CauseList = () => {
//   const [allCauses, setAllCauses] = useState([]);
//   const [visibleCauses, setVisibleCauses] = useState([]);
//   const [filteredCause, setFilteredCause] = useState(null);
// const [defaultDisplayCauses, setDefaultDisplayCauses] = useState([]);
//   const targetCauses = [
//     'Masjid Construction',
//     'Madrasa',
//     'Imaam & Mauzin Funds',
//     'Maktab & syllabaus',
//     'Social Work',
//   ];

//   useEffect(() => {
//   const fetchCauses = async () => {
//     try {
//       const res = await axios.get(`${process.env.REACT_APP_REQUESTING_API}/api/causes`);
//       const sorted = res.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
//       setAllCauses(sorted);

//       const display = targetCauses.map((type) => {
//         const normalizedType = normalize(type);
//         const found = sorted.find((item) => {
//           const itemNorm = normalize(item.cause || '');
//           return itemNorm.includes(normalizedType) || normalizedType.includes(itemNorm);
//         });
//         return found || { cause: type, empty: true };
//       });

//       setDefaultDisplayCauses(display);  // 🔥 store the curated list
//       setVisibleCauses(display);         // 🔥 show curated list on initial load
//     } catch (err) {
//       console.error('Failed to fetch causes:', err);
//     }
//   };

//   fetchCauses();
// }, []);


//   const handleFilter = (causeType) => {
//     const normType = normalize(causeType);
//     const filtered = allCauses.filter((c) =>
//       normalize(c.cause || '').includes(normType) || normType.includes(normalize(c.cause || ''))
//     );
//     setFilteredCause(causeType);
//     setVisibleCauses(filtered);
//   };

// const handleReset = () => {
//   setFilteredCause(null);
//   setVisibleCauses(defaultDisplayCauses);  // ✅ show curated list only
// };

//   const handleDonate = async (cause, donationFor) => {
//   try {
//     const res = await axios.post(`${process.env.REACT_APP_REQUESTING_API}/api/donate`, {
//       amount: 100, // change to your actual amount
//       type: 'onetime',
//       cause,
//       donationFor,
//     });

//     const { order } = res.data;

//     const options = {
//       key: process.env.REACT_APP_RAZORPAY_KEY_ID,
//       amount: order.amount,
//       currency: 'INR',
//       name: 'SUBAI JAMIAT AHLE HADEES ANDHRA PRADESH',
//       description: 'Donation Payment',
//       order_id: order.id,
//       handler: function (response) {
//         alert('Payment successful!');
//         console.log('Payment ID:', response.razorpay_payment_id);
//       },
//       notes: {
//         cause,
//         donationFor,
//       },
//       theme: {
//         color: '#2a9d8f',
//       },
//     };

//     const razor = new window.Razorpay(options);
//     razor.open();
//   } catch (err) {
//     console.error('Payment initiation failed', err);
//     alert('Payment initiation failed');
//   }
// };

//   return (
//     <div className="pb-[700px] md:pb-[420px] lg:pb-[320px]">
//       {/* Hero Banner */}
//       <div className="relative">
//         <img
//           className="object-cover w-full h-[600px] md:h-[800px]"
//           src="images/donaters.jpg"
//           alt="Donation Banner"
//         />
//         <div className="absolute inset-0 flex flex-col justify-center items-center text-center bg-black bg-opacity-50">
//           <h1 className="text-4xl md:text-5xl lg:text-6xl text-white font-bold">
//             وَالَّذِينَ جَاهَدُوا فِينَا لَنَهْدِيَنَّهُمْ سُبُلَنَا
//           </h1>
//           <p className="text-lg md:text-xl text-white p-6 max-w-3xl">
//             "And those who strive for Us, We will surely guide them to Our ways..."
//             <br />
//             <span className="italic">— Surah Al-Ankabut (29:69)</span>
//           </p>
//         </div>
//       </div>

//       {/* Back Button */}
//       {filteredCause && (
//  <div className="text-center pt-12 pb-32 relative z-50">
//   <button
//     onClick={(e) => {
//       e.stopPropagation();
//       handleReset();
//     }}
//     className="bg-gray-500 text-white px-4 py-2 rounded z-50 relative"
//   >
//     Back to All Causes
//   </button>
// </div>

// )}


//      {/* Cause Cards */}
// <div className="relative -mt-[100px] md:-mt-[200px] grid grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 p-5 lg:p-32">
//   {visibleCauses.map((cause, index) => (
//     <div
//       key={index}
//       onClick={() => {
//         if (
//           !filteredCause &&
//           !cause.empty &&
//           ['Masjid Construction', 'Madrasa'].includes(cause.cause)
//         ) {
//           handleFilter(cause.cause);
//         }
//       }}
//       className={`flex flex-col relative ${!cause.empty ? 'cursor-pointer' : 'opacity-50'}`}
//     >
//       <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-200 transform transition-transform duration-300 hover:scale-105 relative flex flex-col h-[650px] overflow-hidden">
        
//         {/* Tag */}
//         <div className="absolute z-50 top-4 right-4 bg-green-500 text-white text-lg px-3 py-1 rounded-full">
//           {cause.cause}
//         </div>

//         {/* Empty placeholder */}
//         {cause.empty ? (
//           <div className="flex flex-col justify-center items-center h-full text-gray-400 italic">
//             No causes available for this category yet.
//           </div>
//         ) : (
//           <>
//             {/* Carousel */}
//             <Carousel showThumbs={false} infiniteLoop autoPlay showIndicators={false}>
//               {cause.images.map((img, i) => (
//                 <div key={i}>
//                   <img
//                     src={`data:image/jpeg;base64,${img}`}
//                     alt={`Image ${i + 1}`}
//                     className="w-full h-80 object-cover"
//                   />
//                 </div>
//               ))}
//             </Carousel>

//             {/* Scrollable Info */}
//             <div className="flex-1 mt-4 space-y-1">
//   <p className="text-gray-700 text-md">
//     <span className="font-semibold">Donation For:</span> {cause.donationFor}
//   </p>
//   <p className="text-gray-700 text-md">
//     <span className="font-semibold">Point of Contact:</span> {cause.name}
//   </p>
//   <p className="text-gray-500 text-md">
//     <span className="font-semibold">Phone:</span> {cause.number}
//   </p>
//   <p className="text-gray-500 text-md line-clamp-2">
//     <span className="font-semibold">Address:</span> {cause.address}
//   </p>
//   <p className="text-gray-500 text-md line-clamp-3">
//     <span className="font-semibold">Description:</span> {cause.description}
//   </p>
// </div>


//             {/* Footer with Donate and Link */}
//             <div className="mt-4">
//               <button
//                 onClick={(e) => {
//                   e.stopPropagation(); // prevent card click
//                   handleDonate(cause.cause, cause.donationFor);
//                 }}
//                 className="w-full px-4 py-2 text-white bg-zinc-500 rounded hover:bg-zinc-800"
//               >
//                 Donate
//               </button>

//               {!filteredCause &&
//                 ['Masjid Construction', 'Madrasa'].includes(cause.cause) && (
//                   <p className="text-center mt-4 text-blue-600 font-semibold underline">
//                     Click to view all {cause.cause} causes
//                   </p>
//               )}
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   ))}
// </div>



//     </div>
//   );
// };

// export default CauseList;





// working 23/06/2025
// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Carousel } from 'react-responsive-carousel';
// import 'react-responsive-carousel/lib/styles/carousel.min.css';

// const normalize = (str) => str?.toLowerCase().replace(/[^a-z]/g, '');

// const CauseList = () => {
//   const [allCauses, setAllCauses] = useState([]);
//   const [visibleCauses, setVisibleCauses] = useState([]);
//   const [filteredCause, setFilteredCause] = useState(null);

//   const targetCauses = [
//     'Masjid Construction',
//     'Madrasa',
//     'Imaam & Mauzin Funds',
//     'Maktab & syllabaus',
//     'Social Work',
//   ];

//   useEffect(() => {
//     const fetchCauses = async () => {
//       try {
//         const res = await axios.get(`${process.env.REACT_APP_REQUESTING_API}/api/causes`);
//         const sorted = res.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
//         setAllCauses(sorted);

//         const display = targetCauses.map((type) => {
//           const normalizedType = normalize(type);
//           const found = sorted.find((item) => {
//             const itemNorm = normalize(item.cause || '');
//             return itemNorm.includes(normalizedType) || normalizedType.includes(itemNorm);
//           });
//           return found || { cause: type, empty: true };
//         });

//         setVisibleCauses(display);
//       } catch (err) {
//         console.error('Failed to fetch causes:', err);
//       }
//     };

//     fetchCauses();
//   }, []);

//   const handleFilter = (causeType) => {
//     const normType = normalize(causeType);
//     const filtered = allCauses.filter((c) =>
//       normalize(c.cause || '').includes(normType) || normType.includes(normalize(c.cause || ''))
//     );
//     setFilteredCause(causeType);
//     setVisibleCauses(filtered);
//   };

//   const handleReset = () => {
//     const display = targetCauses.map((type) => {
//       const normalizedType = normalize(type);
//       const found = allCauses.find((item) => {
//         const itemNorm = normalize(item.cause || '');
//         return itemNorm.includes(normalizedType) || normalizedType.includes(itemNorm);
//       });
//       return found || { cause: type, empty: true };
//     });
//     setFilteredCause(null);
//     setVisibleCauses(display);
//   };

//   const handleDonate = async (cause, donationFor) => {
//   try {
//     const res = await axios.post(`${process.env.REACT_APP_REQUESTING_API}/api/donate`, {
//       amount: 100, // change to your actual amount
//       type: 'onetime',
//       cause,
//       donationFor,
//     });

//     const { order } = res.data;

//     const options = {
//       key: process.env.REACT_APP_RAZORPAY_KEY_ID,
//       amount: order.amount,
//       currency: 'INR',
//       name: 'SUBAI JAMIAT AHLE HADEES ANDHRA PRADESH',
//       description: 'Donation Payment',
//       order_id: order.id,
//       handler: function (response) {
//         alert('Payment successful!');
//         console.log('Payment ID:', response.razorpay_payment_id);
//       },
//       notes: {
//         cause,
//         donationFor,
//       },
//       theme: {
//         color: '#2a9d8f',
//       },
//     };

//     const razor = new window.Razorpay(options);
//     razor.open();
//   } catch (err) {
//     console.error('Payment initiation failed', err);
//     alert('Payment initiation failed');
//   }
// };

//   return (
//     <div className="pb-[700px] md:pb-[420px] lg:pb-[320px]">
//       {/* Hero Banner */}
//       <div className="relative">
//         <img
//           className="object-cover w-full h-[600px] md:h-[800px]"
//           src="images/donaters.jpg"
//           alt="Donation Banner"
//         />
//         <div className="absolute inset-0 flex flex-col justify-center items-center text-center bg-black bg-opacity-50">
//           <h1 className="text-4xl md:text-5xl lg:text-6xl text-white font-bold">
//             وَالَّذِينَ جَاهَدُوا فِينَا لَنَهْدِيَنَّهُمْ سُبُلَنَا
//           </h1>
//           <p className="text-lg md:text-xl text-white p-6 max-w-3xl">
//             "And those who strive for Us, We will surely guide them to Our ways..."
//             <br />
//             <span className="italic">— Surah Al-Ankabut (29:69)</span>
//           </p>
//         </div>
//       </div>

//       {/* Back Button */}
//       {filteredCause && (
//         <div className="text-center m-24">
//           <button
//             onClick={handleReset}
//             className="bg-red-500 text-white px-4 py-2 rounded"
//           >
//             Back to All Causes
//           </button>
//           <h2 className="text-xl font-semibold mt-3">
//             Showing all for: <span className="text-blue-600">{filteredCause}</span>
//           </h2>
//         </div>
//       )}

//       {/* Cause Cards */}
//       <div className="relative -mt-[100px] md:-mt-[200px] grid grid-cols-1 gap-8 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 p-5 lg:p-32">
//         {visibleCauses.map((cause, index) => (
//           <div
//             key={index}
//             onClick={() => {
//               if (
//                 !filteredCause &&
//                 !cause.empty &&
//                 ['Masjid Construction', 'Madrasa'].includes(cause.cause)
//               ) {
//                 handleFilter(cause.cause);
//               }
//             }}
//             className={`flex flex-col relative ${!cause.empty ? 'cursor-pointer' : 'opacity-50'}`}
//           >
//             <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-200 transform transition-transform duration-300 hover:scale-105 relative">
//               {/* Tag */}
//               <div className="absolute z-50 top-4 right-4 bg-blue-500 text-white text-sm px-3 py-1 rounded-full">
//                 {cause.cause}
//               </div>

//               {cause.empty ? (
//                 <div className="flex flex-col justify-center items-center h-64 text-gray-400 italic">
//                   No causes available for this category yet.
//                 </div>
//               ) : (
//                 <>
//                   <Carousel showThumbs={false} infiniteLoop autoPlay showIndicators={false}>
//                     {cause.images.map((img, i) => (
//                       <div key={i}>
//                         <img
//                           src={`data:image/jpeg;base64,${img}`}
//                           alt={`Image ${i + 1}`}
//                           className="w-full h-80 object-cover"
//                         />
//                       </div>
//                     ))}
//                   </Carousel>

//                   <div className="mt-6 space-y-1">
//                     <h2 className="text-xl font-semibold text-gray-800">{cause.donationFor}</h2>
//                     <p className="text-gray-700 text-sm"><span className="font-semibold">Point of:</span> {cause.name}</p>
//                     <p className="text-gray-500 text-sm"><span className="font-semibold">Phone:</span> {cause.number}</p>
//                     <p className="text-gray-500 text-sm"><span className="font-semibold">Address:</span> {cause.address}</p>
//                     <p className="text-gray-600 text-sm mt-2 line-clamp-3">{cause.description}</p>

//                     {/* Donate Button (Always visible) */}
//                   <button
//   onClick={(e) => {
//     e.stopPropagation(); // prevent card click
//     handleDonate(cause.cause, cause.donationFor);
//   }}
//   className="w-full px-4 mt-6 py-2 text-white bg-zinc-500 rounded hover:bg-zinc-800"
// >
//   Donate
// </button>


//                     {/* Click to view all (only for Masjid/Madrasa) */}
//                     {!filteredCause && ['Masjid Construction', 'Madrasa'].includes(cause.cause) && (
//                       <p className="text-center mt-4 text-blue-600 font-semibold underline">
//                         Click to view all {cause.cause} causes
//                       </p>
//                     )}
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default CauseList;




